import { apiFetch } from "../client"

export async function listAuditLogs(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/audit-logs${query}`)
}

export function getAuditExportUrl(params?: Record<string, string>) {
  const query = new URLSearchParams({ ...(params ?? {}), format: "csv" }).toString()
  return `/api/v1/audit-logs?${query}`
}
